export default function replaceContact(string: string, ats?: string) {
  const auctionMail =
    process.env.NEXT_PUBLIC_AUCTION_MAIL || process.env.NEXT_PUBLIC_MAIL;
  string = string.replaceAll(' />', '/>');
  string = string.replaceAll(
    '<auctionMailLink/>',
    `<a href="mailto:${auctionMail}" class='underline'>${auctionMail}</a>`
  );
  string = string.replaceAll(
    '<mailLink/>',
    `<a href="mailto:${process.env.NEXT_PUBLIC_MAIL}" class='underline'>${process.env.NEXT_PUBLIC_MAIL}</a>`
  );
  string = string.replaceAll(
    '<phoneLink/>',
    `<a href="tel:${String(process.env.NEXT_PUBLIC_PHONE).replaceAll(' ', '')}" class='underline'>${process.env.NEXT_PUBLIC_PHONE}</a>`
  );
  string = string.replaceAll(
    '<siblingLink/>',
    `<a href="${String(process.env.NEXT_PUBLIC_SIBLING_SITE_URL).replaceAll(' ', '')}" class='underline text-brand'>${String(process.env.NEXT_PUBLIC_SIBLING_SITE_URL).replaceAll('https://', '')}</a>`
  );
  if (ats) {
    string = string.replaceAll('{ats}', ats);
  }
  return string;
}
